var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideNotifications(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 14",
    preserveAspectRatio: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7 H86.4",
    fill: "none",
    stroke: "#C04DD8",
    strokeWidth: 3,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86 7 L90 16 L94 7",
    fill: "none",
    stroke: "#C04DD8",
    strokeWidth: 3,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 20,
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6 7 H100",
    fill: "none",
    stroke: "#C04DD8",
    strokeWidth: 3,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideNotifications);
export default __webpack_public_path__ + "static/media/hide_notifications.1d83061a1b918dd45a7e5a24d5f88d1b.svg";
export { ForwardRef as ReactComponent };